<template>
  <ErrorPageBase :statusCode="403">
    現在、このページ・またはファイルへのアクセスは禁止されています。<br />
    ご不明の点は、運営まで<ExternalLink :href="contactUrl" :class="$style.link"
      >お問い合わせ</ExternalLink
    >下さい。
  </ErrorPageBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { SHADOW_CONTACT_URL } from '@/config'
import ErrorPageBase from './ErrorPageBase.vue'
import ExternalLink from '@/components/atoms/ExternalLink.vue'

export default defineComponent({
  name: 'ErrorForbidden',
  components: {
    ErrorPageBase,
    ExternalLink,
  },
  computed: {
    contactUrl() {
      return SHADOW_CONTACT_URL
    },
  },
})
</script>

<style lang="scss" module>
.link {
  color: $color-text-and-object-accent-primary;
}
</style>
